import React from 'react'
import agent from '../agent'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { store } from '../store'
import { push } from 'react-router-redux'
import ListErrors from './widgets/ListErrors'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'
import {
    RESETPASSWORD,
    RESETPASSWORD_PAGE_UNLOADED,
    CLEAR_REDIRECT
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    inProgress: state.common.inProgress,
    email: state.router.location.state ? state.router.location.state.email : null,
})

const mapDispatchToProps = dispatch => ({
    onSubmit: (payload) => {
        dispatch({ type: RESETPASSWORD, payload, redirectTo: 'Login' })
    },
    onUnload: () => dispatch({ type: RESETPASSWORD_PAGE_UNLOADED }),
    onRedirect: () =>
        dispatch({ type: CLEAR_REDIRECT })
});

class VerifyResetPassword extends React.Component {
    constructor() {
        super()
        this.state = {
            email: '',
            code: '',
            password: '',
            passwordAgain: ''
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.submitForm = (email, code, password) => ev => {
            ev.preventDefault()
            const payload = agent.Auth.resetPassword(email, code, password)
            this.props.onSubmit(payload)
        }
    }
    componentWillMount() {
        if (this.props.email) {
            Object.assign(this.state, {
                email: this.props.email,
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    render() {
        const email = this.state.email
        const code = this.state.code
        const password = this.state.password
        const passwordAgain = this.state.passwordAgain
        const inProgress = this.props.inProgress
        return (
            <Translation>
                {
                    (t) => (
                        <div id="focus">
                            <div id="focus-header"><h1>{t('system.name')}</h1></div>
                            <div className="main">
                                <div className="main-wrap">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2>{t('authentication.reset_password_title')}</h2>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('input_label.email')}</label>
                                            <input type="text" placeholder="Email" value={email} onChange={this.updateState('email')} />
                                        </div>
                                        <div className="form-item">
                                            <label>{t('input_label.verification_code')}</label>
                                            <input type="text" placeholder="Code" value={code} onChange={this.updateState('code')} />
                                        </div>
                                        <div className="form-item">
                                            <label>{t('input_label.password_new')}</label>
                                            <input type="password" placeholder="New Password" value={password} onChange={this.updateState('password')} />
                                        </div>
                                        <ListErrors errors={this.props.errors} />
                                        <div className="form-item">
                                            <button onClick={this.submitForm(email, code, password)}>{this.props.inProgress ? t('authentication.reset_button_progress') : t('authentication.reset_button')}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyResetPassword)
